/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from 'vue'
import Vuex from 'vuex'
import { createDirectStore } from 'direct-vuex'
import Calendar from './modules/Calendar'
import Login from './modules/Login'
import Timesheet from './modules/Timesheet'
import Users from './modules/Users'
import MemberTags from './modules/MemberTags'
import Masters from './modules/Masters'
import InformationBoard from './modules/InformationBoard'
import Home from './modules/Home'
import ExcelDownload from './modules/ExcelDownload'
import PrivacyWord from './modules/PrivacyWord'
import Project from './modules/Project'
import ProjectAssign from './modules/ProjectAssign'
import Tenant from './modules/Tenant'
import Github from './modules/Github'
import PersonalTime from './modules/PersonalTime'
import App from './modules/app'
import ProjectReport from './modules/ProjectReport'
Vue.use(Vuex)

const {
  store,
  rootActionContext,
  moduleActionContext,
  rootGetterContext,
  moduleGetterContext
} = createDirectStore({
  modules: {
    Calendar,
    Login,
    Timesheet,
    Users,
    MemberTags,
    Masters,
    InformationBoard,
    Home,
    ExcelDownload,
    PrivacyWord,
    Tenant,
    Github,
    Project,
    ProjectAssign,
    PersonalTime,
    App,
    ProjectReport
  }
})
export default store
export {
  rootActionContext,
  moduleActionContext,
  rootGetterContext,
  moduleGetterContext
}
export type AppStore = typeof store
declare module 'vuex' {
  interface Store<S> {
    direct: AppStore;
  }
}
